import { Box, Divider } from '@rbilabs/universal-components';

import {
  CopyButton,
  IDebugMenuEntity,
  OneMenuInfo,
  PluInfo,
  StoreInfo,
  useDebugMenuItemData,
} from 'components/debug-tool';
import { Typography } from 'components/ui';
import { MenuObjectTypes } from 'enums/menu';

import { getSanityDocumentUrl } from '../utils';

export const SelectedItemDebug = ({
  selectedItemVendorConfig,
  productName,
  selectedItemType,
  oneMenuEntryId,
  contextualPrice,
  hideTitle = false,
  hidePosVendor = false,
}: {
  selectedItemVendorConfig: IDebugMenuEntity;
  productName: string;
  selectedItemType: MenuObjectTypes;
  oneMenuEntryId?: string;
  contextualPrice?: Parameters<typeof useDebugMenuItemData>[0]['contextualPrice'];
  hideTitle?: boolean;
  hidePosVendor?: boolean;
}) => {
  const debugData = useDebugMenuItemData({
    entity: selectedItemVendorConfig,
    entryId: oneMenuEntryId,
    contextualPrice,
  });

  return (
    <Box marginY="$2">
      {!hidePosVendor && (
        <>
          <StoreInfo />
          <Divider marginBottom="$6" />
        </>
      )}
      {!hideTitle && <Typography variant="headerOne">Selected Product:</Typography>}
      <CopyButton
        label={productName}
        textToCopy={getSanityDocumentUrl(selectedItemType, debugData.sanityDocumentId)}
        variant="headerTwo"
        iconName="mi:content-copy"
      />
      {debugData.isOneMenu ? (
        <OneMenuInfo
          entryId={debugData.oneMenuEntryId}
          posIdsConfiguration={debugData?.posIdsConfiguration}
          price={debugData.price}
          priceStatus={debugData.priceStatus}
        />
      ) : debugData.vendorConfig ? (
        <PluInfo vendorConfig={debugData.vendorConfig} />
      ) : (
        <Typography variant="copyOne" my="$2">
          Vendor configuration not found
        </Typography>
      )}
    </Box>
  );
};
